import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '100%',
    margin: 0,
  },
  title: {
    fontWeight: 'bold',
  },
  header: {
    backgroundColor: '#F9FCFF',
    paddingLeft: theme.spacing(2),
  },
  label: {
    whiteSpace: 'nowrap',
    color: '#4D4F5C',
    fontSize: 13,
  },
  dateInput: {
    height: 42,
    margin: 0,
  },
  textField: {
    height: 42,
    margin: 0,
    marginTop: 19,
  },
  checkBox: {
    marginTop: theme.spacing(1.8),
  },
  tableTitleWrapper: {
    backgroundColor: '#FFFFFF',
    borderRadius: 0,
    height: 64,
    margin: `${-theme.spacing(2)}px ${-theme.spacing(7)}px ${theme.spacing(3)}px ${-theme.spacing(
      4
    )}px`,
    paddingLeft: theme.spacing(4),
    display: 'flex',
    alignItems: 'center',
  },
  searchIcon: {
    '& svg': {
      color: '#777',
      width: 16,
    },
  },
  searchField: {
    marginTop: 6,
  },
  switchWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
}));

const switchStyles = makeStyles((theme) => ({
  label: {
    color: theme.palette.subtitle,
    fontSize: 13,
  },
}));

export { useStyles, switchStyles };
